import * as React from 'react'

import { DAY_TYPES } from 'config/Vars'

import AllowanceIncidenceForm from 'modules/timeoff/lib/AllowanceIncidence'
import type AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'

const incidenceAttrs = (incidence: AllowanceIncidence): Record<string, any> => ({
  ...incidence.toJS(),
  sign: incidence.attributes.days_in_cents < 0 ? '-1' : '1',
  target_balance: incidence.attributes.target_balance
    ? incidence.attributes.target_balance
    : 'available',
  day_type:
    Math.abs(incidence.attributes.days_in_cents) === 50 ? DAY_TYPES.half_day : DAY_TYPES.days,
})

interface Props {
  employeeId: number
  incidence?: AllowanceIncidence
}

const noop = () => {}
const Context = React.createContext<(value: boolean) => void>(noop)

export const FormErrorProvider = ({
  action,
  children,
}: {
  action: (value: boolean) => void
  children: React.ReactNode
}) => <Context.Provider value={action}>{children}</Context.Provider>

export const useFormError = (): ((value: boolean) => void) => {
  return React.useContext(Context)
}

const useForm = ({ employeeId, incidence }: Props): AllowanceIncidenceForm => {
  const newIncidenceAttrs = {
    sign: '1',
    timeoff_allowance_id: 0,
    day_type: DAY_TYPES.days,
    employee_id: employeeId,
    target_balance: 'available',
    _skip_notifications: false,
  }

  return React.useRef<AllowanceIncidenceForm>(
    new AllowanceIncidenceForm(incidence ? incidenceAttrs(incidence) : newIncidenceAttrs)
  ).current
}

export default useForm
